function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _isObjectEmpty = function _isObjectEmpty(obj) {
  // Could probably be simplified to: return Object.keys(obj).length === 0
  for (var prop in obj) {
    if (obj[prop] !== '') return false;
  }
  return true;
};
export var isEmpty = function isEmpty(val) {
  if (val === null || val === undefined) return true;
  return typeof val === 'string' ? !val.trim().length : _typeof(val) === 'object' ? _isObjectEmpty(val) : typeof val === 'boolean' || typeof val === 'number' && val > -1 ? false : true;
};